// extracted by css-extract-rspack-plugin
export default {"saveWithUltraPack":"gslwXkZJ1asiCpke","ultraPackPrice":"dqKFwu60CY1DREsi","ultraPriceDescription":"BqcPqZDl14MIgqR3","geoTax":"ghHN5FG5GY0qt5ZR"};